export function ProjectDetailSkeleton() {
  return (
    <div className="mx-auto max-w-[var(--max-width-container)] animate-pulse px-4 pt-6 pb-18 md:px-8">
      {/* Header row: back button placeholder */}
      <div className="mb-6 flex items-center justify-between">
        <div className="h-9 w-24 rounded-lg bg-alpha-black-10" />
      </div>

      <div className="max-w-[1216px] space-y-6">
        {/* Main project card */}
        <div className="rounded-2xl border border-secondary bg-primary p-6 shadow-xs md:p-8">
          {/* Top row: research badge + not-interested button */}
          <div className="mb-4 flex items-center justify-between">
            <div className="h-6 w-28 rounded-full bg-alpha-black-10" />
            <div className="h-8 w-32 rounded-lg bg-alpha-black-10" />
          </div>

          {/* Title */}
          <div className="mb-3 h-8 w-2/3 rounded bg-alpha-black-10" />

          {/* Description */}
          <div className="mb-8 space-y-2">
            <div className="h-4 w-full rounded bg-alpha-black-10" />
            <div className="h-4 w-full rounded bg-alpha-black-10" />
            <div className="h-4 w-3/5 rounded bg-alpha-black-10" />
          </div>

          {/* Metadata row: reward + duration */}
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <div className="size-5 rounded bg-alpha-black-10" />
              <div className="h-5 w-16 rounded bg-alpha-black-10" />
            </div>
            <div className="flex items-center gap-2">
              <div className="size-5 rounded bg-alpha-black-10" />
              <div className="h-5 w-20 rounded bg-alpha-black-10" />
            </div>
          </div>

          {/* Actions row: apply button + screener questions */}
          <div className="mt-8 flex items-center gap-4">
            <div className="h-11 w-28 rounded-lg bg-alpha-black-10" />
            <div className="h-5 w-36 rounded bg-alpha-black-10" />
          </div>
        </div>

        {/* What to Expect section placeholder */}
        <div className="rounded-2xl border border-secondary bg-primary p-6 shadow-xs md:p-8">
          <div className="mb-4 h-6 w-40 rounded bg-alpha-black-10" />
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="mt-0.5 size-5 shrink-0 rounded-full bg-alpha-black-10" />
                <div className="h-5 w-full rounded bg-alpha-black-10" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
